<template>
    <transition name="modal">
        <div class="modal-mask modal-lg">
            <div class="modal-wrapper">
                <div class="modal-container">
                    <div class="modal-header">
                        <button type="button" class="close" @click="$emit('close')">
                            <span aria-hidden="true">×</span><span class="sr-only">Close</span>
                        </button>
                          <h3>field mapping</h3>
                    </div>
                    <div class="modal-body">
                        <slot name="body">
                            <form class="form-horizontal">
                                
                                <div class="form-group">
                                  <label class="col-sm-2 control-label">First Name</label>
                                  <div class="col-sm-10">
                                    <select class="form-control" v-model="fieldMappingModel.first_name">
                                      <option value="null" disabled hidden>Pick one field</option>
                                      <option v-for="choice in fieldList" :value="choice.id">{{choice.name}}</option>
                                    </select>
                                  </div>
                                </div>

                                <div class="form-group">
                                  <label class="col-sm-2 control-label">Middle Name</label>
                                  <div class="col-sm-10">
                                    <select class="form-control" v-model="fieldMappingModel.middle_name">
                                      <option value="null" disabled hidden>Pick one field</option>
                                      <option v-for="choice in fieldList" :value="choice.id">{{choice.name}}</option>
                                    </select>
                                  </div>
                                </div>

                                <div class="form-group">
                                  <label class="col-sm-2 control-label">Last Name</label>
                                  <div class="col-sm-10">
                                    <select class="form-control" v-model="fieldMappingModel.last_name">
                                      <option value="null" disabled hidden>Pick one field</option>
                                      <option v-for="choice in fieldList" :value="choice.id">{{choice.name}}</option>
                                    </select>
                                  </div>
                                </div>

                                <div class="form-group">
                                  <label class="col-sm-2 control-label">Primary Email Address</label>
                                  <div class="col-sm-10">
                                    <select class="form-control" v-model="fieldMappingModel.primary_email_address">
                                      <option value="null" disabled hidden>Pick one field</option>
                                      <option v-for="choice in fieldList" :value="choice.id">{{choice.name}}</option>
                                    </select>
                                  </div>
                                </div>

                                <div class="form-group">
                                  <label class="col-sm-2 control-label">Primary Phone Number</label>
                                  <div class="col-sm-10">
                                    <select class="form-control" v-model="fieldMappingModel.primary_phone_number">
                                      <option value="null" disabled hidden>Pick one field</option>
                                      <option v-for="choice in fieldList" :value="choice.id">{{choice.name}}</option>
                                    </select>
                                  </div>
                                </div>

                                <div class="form-group">
                                  <label class="col-sm-2 control-label">Street Address (First Line)</label>
                                  <div class="col-sm-10">
                                    <select class="form-control" v-model="fieldMappingModel.street_address_line1">
                                      <option value="null" disabled hidden>Pick one field</option>
                                      <option v-for="choice in fieldList" :value="choice.id">{{choice.name}}</option>
                                    </select>
                                  </div>
                                </div>

                                <div class="form-group">
                                  <label class="col-sm-2 control-label">Street Address (Second Line)</label>
                                  <div class="col-sm-10">
                                    <select class="form-control" v-model="fieldMappingModel.street_address_line2">
                                      <option value="null" disabled hidden>Pick one field</option>
                                      <option v-for="choice in fieldList" :value="choice.id">{{choice.name}}</option>
                                    </select>
                                  </div>
                                </div>

                                <div class="form-group">
                                  <label class="col-sm-2 control-label">Zip-code</label>
                                  <div class="col-sm-10">
                                    <select class="form-control" v-model="fieldMappingModel.zipcode">
                                      <option value="null" disabled hidden>Pick one field</option>
                                      <option v-for="choice in fieldList" :value="choice.id">{{choice.name}}</option>
                                    </select>
                                  </div>
                                </div>

                                <div class="form-group">
                                  <label class="col-sm-2 control-label">City</label>
                                  <div class="col-sm-10">
                                    <select class="form-control" v-model="fieldMappingModel.city">
                                      <option value="null" disabled hidden>Pick one field</option>
                                      <option v-for="choice in fieldList" :value="choice.id">{{choice.name}}</option>
                                    </select>
                                  </div>
                                </div>

                                <div class="form-group">
                                  <label class="col-sm-2 control-label">State</label>
                                  <div class="col-sm-10">
                                    <select class="form-control" v-model="fieldMappingModel.state">
                                      <option value="null" disabled hidden>Pick one field</option>
                                      <option v-for="choice in fieldList" :value="choice.id">{{choice.name}}</option>
                                    </select>
                                  </div>
                                </div>

                                <div class="form-group">
                                  <label class="col-sm-2 control-label">Country</label>
                                  <div class="col-sm-10">
                                    <select class="form-control" v-model="fieldMappingModel.country">
                                      <option value="null" disabled hidden>Pick one field</option>
                                      <option v-for="choice in fieldList" :value="choice.id">{{choice.name}}</option>
                                    </select>
                                  </div>
                                </div>

                                <div class="form-group">
                                  <label class="col-sm-2 control-label">Date of Birth</label>
                                  <div class="col-sm-10">
                                    <select class="form-control" v-model="fieldMappingModel.birthday">
                                      <option value="null" disabled hidden>Pick one field</option>
                                      <option v-for="choice in fieldList" :value="choice.id">{{choice.name}}</option>
                                    </select>
                                  </div>
                                </div>

                            </form>
                        </slot>
                    </div>

                    <div class="modal-footer">
                        <slot name="footer">
                            <button type="button" class="btn btn-custom" 
                                    @click="saveFieldMapping()">Save changes</button>
                        </slot>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>


<script>
// Load the full build. 
var _ = require('lodash');

export default {

  props: {
    fieldList: {
      type: Array,
    },
  },

  data () {
    return {
      fieldMappingModel: {
        first_name: null,
        middle_name: null,
        last_name: null,
        primary_email_address: null,
        primary_phone_number: null,
        street_address_line1: null,
        street_address_line2: null,
        zipcode: null,
        city: null,
        state: null,
        country: null,
        birthday: null,
      }
    };
  },

  created () {
    this.init();
  },

  methods: {
    init () {
      var self = this;

      var user = self.$auth.fetch({
        success: function () {
          var user = self.$auth.user();
          var account = user.current_account;
          var fieldMapping = account.field_mapping;
          if (fieldMapping) {
            self.fieldMappingModel = fieldMapping;
          }
        },
      });
    },

    saveFieldMapping: _.debounce(function () {
      var self = this;
      API.fieldMappings.save(self.fieldMappingModel)
        .then(function (response) {
          // closing modal
          self.$emit('close', true);
        });
    })
  }

}
</script>


<style>
.form-dashboard .select2-container {
  width: 100% !important;
}
.form-dashboard #reportrange {
  background: rgb(255, 255, 255);
  cursor: pointer;
  padding: 5px 10px;
  border: 1px solid rgb(204, 204, 204);
  display: inline-block;
}
.form-dashboard .select2-container--default .select2-selection--single .select2-selection__rendered {
  padding: 6px 12px;
  height: 34px;
  line-height: 1.42857143;
}
.form-dashboard .select2-container .select2-selection--single {
  height: 34px;
  border: 1px solid #ccc;
  border-radius: 4px;
}
.form-dashboard .select2-container--default .select2-selection--single .select2-selection__arrow {
  position: absolute;
  top: 35%;
  margin-top: -8px;
  right: .5em;
}
.form-dashboard .select2-container--default .select2-selection--single .select2-selection__arrow b {
  border-color: #616161 transparent transparent transparent;
}
.form-dashboard .comiseo-daterangepicker-triggerbutton.ui-button {
  width: 100%;
  height: 34px;
  padding: 6px 12px;
  font-size: 14px;
  line-height: 1.42857143;
  color: #555;
  background-color: #fff;
  background-image: none;
  border: 1px solid #ccc;
  border-radius: 4px;
}
.form-dashboard .dropdown-toggle-filters {
  width: 100%;
  text-align: left;
}
.form-dashboard .dropdown-toggle-filters .caret {
  float: right;
  margin: 8px 0;
  color: #616161;
}
</style>



// WEBPACK FOOTER //
// FieldMappingModal.vue?76afaf50